const state = {
    data: []
}

const mutations = {
    storePages (state, payload) {
        state.data = payload
    },
    updatePage (state, payload) {
        let curPage = state.data.find(item => item.id === payload.id)

        curPage = payload
    },
    changePageState (state, payload) {
        const curPage = state.data.find(item => item.id === payload.id)

        curPage.status = payload.status
    }
}

const actions = {}

const getters = {
    getPages: state => state.data
}

export default {
    state,
    mutations,
    actions,
    getters
}
